module.exports = __webpack_public_path__ + "img/logo_cn.224ecaba.png";